import { render } from "./sportButtonSelector.vue?vue&type=template&id=3134e7f8&scoped=true"
import script from "./sportButtonSelector.vue?vue&type=script&lang=js"
export * from "./sportButtonSelector.vue?vue&type=script&lang=js"

import "./sportButtonSelector.vue?vue&type=style&index=0&id=3134e7f8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3134e7f8"]])

export default __exports__